// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/marshalling-signals.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/marshalling-signals/marshalling-signals.js';

mount([g0]);
